<template>
    <div>
    <!--
       <div style="position: absolute; width: 100%; height: 2000px; z-index:1;background-color: #ffffff;">
            <h3 style="margin-top: 100px; text-align: center;padding: 40px;">Wait as the PDF is being generated</h3>
            <div class="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
        </div> 
    -->    
    
    <PdfModal @close="closeModal" :style="{ backgroundColor: '#ffffff' }">
        <template v-slot:header>
            <h5 class="fw-bold">PDF Preview</h5>
        </template>

        <template v-slot:body>
            <div style=" padding: 10px; min-height: 100vh;">
                <div v-if="loading" class="text-center" style="padding: 40px;">
                    <div class="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
                    <p style="margin-top: 13px; font-weight: bold;">Loading purchase data...</p>
                </div>
                <div v-if="!loading" class="pdf pdf-preview-root" id="pdfStart" style="margin: 5px; padding: 20px; position: relative;">
                <div v-if="isPurchaseRejected" class="po-rejected-watermark" aria-hidden="true">REJECTED</div>
                <div class="row">
                    <div class="col-md-7">
                        <h5 class="fw-bold">Purchase Order</h5>
                    </div>
                    <div class="col-md-5 d-flex justify-content-end align-items-center mb-3">
                        <img :src="defaultLogo" style="height: 80px; width: 175px;"/>
                    </div>
        
                   
                    
                    <div class="col-md-7">
                        <div style="width: 400px;">
                            <h5 class="fw-bold">{{ profile.businessName }}</h5>
                            <p class="mb-4 org-address">{{ profile.businessAddress }}</p>

                            <div class="d-flex justify-content-start align-items-center gap-2">
                                <p class="mb-3 mr-4 fw-bold" style="width: fit-content; color: black !important;"><strong>VAT No: </strong></p>
                                <p class="org-address">{{ profile?.businessVatNo }}</p>
                            </div>
                
                            <h6 class="fw-bold mt-5">{{ purchase.Supplier?.name }}</h6>
                            <p class="mb-4 org-address">{{ purchase.Supplier?.address }}</p>
                        </div>
                    </div>
                 

                    <div class="col-md-5 d-flex align-items-end flex-column mt-5">
                        
                        <div class="d-flex justify-content-end align-items-center gap-2 fit-content">
                            <p class="mr-4 fw-bold text-start" style="color: black !important; width: 110px;"><strong>Number: </strong></p>
                            <p class="org-address text-end"  style="width: 110px;">{{ purchase?.purchaseNo }}</p>
                        </div>
                         <div class="d-flex justify-content-end align-items-center gap-2 fit-content">
                            <p class="mr-4 fw-bold text-start  " style="color: black !important; width: 110px;"><strong>Date: </strong></p>
                            <p class="org-address text-end" style="width: 110px;">{{ formatDate(purchase?.createdAt) }}</p>
                        </div>
                        <div class="d-flex justify-content-end align-items-center gap-2 fit-content">
                            <p class="mr-4 fw-bold text-start" style="color: black !important; width: 110px;"><strong>Page: </strong></p>
                            <p class="org-address text-end" style="width: 110px;">1</p>
                        </div>
                        <div class="d-flex justify-content-end align-items-center gap-2 fit-content">
                            <p class="mr-4 fw-bold text-start" style="color: black !important; width: 110px;"><strong>Reference: </strong></p>
                            <p class="org-address text-end" style="width: 110px;">{{ purchase?.project }}</p>
                        </div>
                        <div class="d-flex justify-content-end align-items-center gap-2 fit-content">
                            <p class="mr-4 fw-bold text-start" style="color: black !important; width: 110px;"><strong>Delivery Date: </strong></p>
                            <p class="org-address text-end" style="width: 110px;">{{ purchase?.expectedDeliveryDate ? formatDate(purchase.expectedDeliveryDate) : (purchase?.deliveryDate ? formatDate(purchase.deliveryDate) : '') }}</p>
                        </div>
                        <div class="d-flex justify-content-end align-items-center gap-2 fit-content">
                            <p class="mr-4 fw-bold text-start" style="color: black !important; width: 110px;"><strong>Discount: </strong></p>
                            <p class="org-address text-end"  style="width: 110px;">{{ purchase?.discount || '0.00' }} %</p>
                        </div>

                        <div class="d-flex justify-content-between align-items-center  fit-content bg-light p-2" style="background-color: #f2f2f2 !important;">
                            <p class="mr-4 fw-bold text-start" style="color: black !important; width: 110px; background-color: #f2f2f2 !important;"><strong>Total Due: </strong></p>
                            <p class="org-address text-end"  style="width: 110px; background-color: #f2f2f2 !important;">{{ formatMoney(totalFinal, currency) }}</p>
                        </div>
                        <!--<canvas ref="qrcodeCanvas"></canvas>-->
                        
                    </div>
                    
                    <div class="col-md-7">
                        <div v-if="purchaseItemVehicles.length > 0" class="d-flex justify-content-start align-items-start gap-2 mb-1">
                            <p class="mb-0 mr-4 fw-bold" style="width: fit-content; color: black !important;"><strong>Vehicle: </strong></p>
                            <p class="mb-0 org-address">{{ purchaseItemVehicleLabels }}</p>
                        </div>
                        
                        <div class="d-flex justify-content-start align-items-center gap-2 mb-1">
                            <p class="mb-0 mr-4 fw-bold" style="width: fit-content; color: black !important;"><strong>Supplier VAT No: </strong></p>
                            <p class="mb-0 org-address">{{ purchase?.Supplier?.idNumber || purchase?.idNumber }}</p>
                        </div>
                        
                    </div>
                    <div class="col-md-5" id="companyDetails">
        
                    </div>
                </div>
        
                <div class="row">
                    <table class="table">
                        <tbody v-if="purchase.PurchaseProduct?.length > 0">
                            <tr class="bg-light" style="background-color: #f2f2f2 !important;">
                                <th style="background-color:#f2f2f2 !important; color:#000 !important;">No.</th>
                                <th style="background-color:#f2f2f2 !important; color:#000 !important;">Description</th>
                                <th style="background-color:#f2f2f2 !important; color:#000 !important;">Quantity</th>
                                <th style="background-color:#f2f2f2 !important; color:#000 !important;">Excl. Price</th>
                                <th style="background-color:#f2f2f2 !important; color:#000 !important;" class="text-end">Total</th>
                            </tr>
                            <tr v-for="(item, index) in (purchase.PurchaseProduct || []).filter(i => i)" v-bind:key="item?.id ?? index">
                                <td style="padding: 2px 8px !important;">{{ (index+1) }}</td>
                                <td style="padding: 2px 8px !important;">{{ (item?.Product?.name) || (item?.Service?.name) || item?.description || '-' }}</td>
                                <td style="padding: 2px 8px !important;">{{ item.quantity }}</td>
                                <td style="padding: 2px 8px !important;">{{ formatMoney(Number(item.price) || 0, currency) }}</td>
                                <td class="text-end" style="padding: 2px 8px !important;">{{ formatMoney((Number(item.price) || 0) * (Number(item.quantity) || 0), currency) }}</td>
                            </tr>
                                 <tr>
                                <td style="border-bottom: 0px !important"></td>
                                <td style="border-bottom: 0px !important"></td>
                                <td style="border-bottom: 0px !important"></td>
                                <td style="border-bottom: 0px !important" class="fw-bold">Total Discount:</td>
                                <td style="border-bottom: 0px !important" class="text-end">{{ formatMoney(discountAmount, currency) }}</td></tr>
                                 <tr>
                                <td style="border-bottom: 0px !important"></td>
                                <td style="border-bottom: 0px !important"></td>
                                <td style="border-bottom: 0px !important"></td>
                                <td style="border-bottom: 0px !important" class="fw-bold">Total Exclusive:</td><td style="border-bottom: 0px !important" class="text-end">{{ formatMoney(totalPrice - discountAmount, currency) }}</td></tr>
                            <tr v-if="purchase.vat">
                                <td style="border-bottom: 0px !important"></td>
                                <td style="border-bottom: 0px !important"></td>
                                <td style="border-bottom: 0px !important"></td>
                                <td style="border-bottom: 0px !important" class="fw-bold">Total VAT:</td>
                                <td style="border-bottom: 0px !important" class="text-end">{{ formatMoney(totalVat, currency) }}</td></tr>
                            <tr>
                                <td style="border-bottom: 0px !important; margin-bottom:20px;"></td>
                                <td style="border-bottom: 0px !important; margin-bottom:20px;"></td>
                                <td style="border-bottom: 0px !important; margin-bottom:20px;"></td>
                                <td style="border-bottom: 0px !important; font-weight: bold; background-color: #f2f2f2 !important; margin-bottom:20px;">Total Due:</td>
                                <td style="border-bottom: 0px !important; font-weight: bold; background-color: #f2f2f2 !important; margin-bottom:20px;" class="text-end">{{ formatMoney(totalFinal, currency) }}</td>
                            </tr>
                        </tbody>
                        <div v-else>
                            <label for="" class="text-danger" style="margin: 10px auto; text-align: center; display: block;">No items found</label>
                        </div>
                    </table>
                </div>
                
                <div class="row mt-3" v-if="purchase.termsAndConditions">
                    <div class="col-12">
                        <p style="font-weight: bold; margin-bottom: 5px;">Terms and Conditions</p>
                        <p style="white-space: pre-wrap; font-size: 12px;">{{ purchase.termsAndConditions }}</p>
                    </div>
                </div>
                
                <!--
                <div class="row" style="border: 1px solid #000;">
                    <p style="background-color: #C1D4EB;padding: 10px; margin:0px; font-weight: bold !important;">Comments</p>
                    <p style="margin-left: 0px;">{{ purchase.approveComment }}</p>
                </div>
                <div class="row" id="footer">
                    <div class="col-md-5">
                        <p><span style="font-weight: bold;">Note:</span> Printed document is uncontrolled</p>
                    </div>
                    <div class="col-md-4">
                        <p><span style="font-weight: bold;">Printed On:</span> {{ formatDate(new Date(),"true") }}</p>
                    </div>
                    <div class="col-md-3">
                        <p><span style="font-weight: bold;">By:</span> {{ user?.name || '-' }}</p>
                    </div>
                </div>-->
                <p style="margin-bottom: 0px; font-size: 18px !important;">Approvals;</p>
                <div class="row">
                    <!--<div class="col-md-6">
                        <img v-if="purchase.User?.signature" :src="`${urlServer}/files/${purchase.User?.signature}`" alt="" style="max-height: 100px !important; width: auto !important;"/>
                        <p style="margin-bottom: 0px; font-weight: bold !important; font-size: 18px !important;">Purchase Order By;</p>
                        <p style="margin-bottom: 0px;"><span style="font-weight: bold;">Name:</span> {{ purchase.User?.name }}</p>
                        <p style="margin-bottom: 0px;"><span style="font-weight: bold;">System ID:</span> {{ purchase.User?.id }}</p>
                        <p style="margin-bottom: 0px;"><span style="font-weight: bold;">Date:</span> {{ formatDate(purchase.createdAt,"true") }}</p>
                    </div>
                    <div class="col-md-6" v-if="actionedBy">
                        <img v-if="actionedBy?.signature" :src="`${urlServer}/files/${actionedBy?.signature}`" alt="" style="max-height: 100px !important; width: auto !important;"/>
                        <p style="margin-bottom: 0px; font-weight: bold !important; font-size: 18px !important;">Purchase Order Approved/Cancelled By;</p>
                        <p style="margin-bottom: 0px;"><span style="font-weight: bold;">Name:</span> {{ actionedBy?.name }}</p>
                        <p style="margin-bottom: 0px;"><span style="font-weight: bold;">System ID:</span> {{ actionedBy?.id }}</p>
                        <p style="margin-bottom: 0px;"><span style="font-weight: bold;">Date:</span> {{ formatDate(purchase.updatedAt,"true") }}</p>
                    </div>-->
                                        <div class="col-md-2" v-if="purchase?.tenderId">
                                                <p style="margin-bottom: 0px; font-size: 18px !important;">Requester;</p>
                                                <img
                                                    v-if="requesterUser && requesterUser.signature"
                                                    :src="fileUrl(requesterUser.signature)"
                                                    alt=""
                                                    style="max-height: 80px !important; width: auto !important;"
                                                />
                                                <p style="margin-bottom: 0px;">{{ requesterUser?.name || '-' }}</p>
                                                <p style="margin-bottom: 0px;">{{ formatDate(requesterDate, false) }}</p>
                                        </div>
                    <div class="col-md-2" style="margin-right: 16px;">
                        <p style="margin-bottom: 0px; font-size: 18px !important;">Procurement;</p>
                        <div v-if="approvalSignatures()[0]?.isRejected" style="color: #b41e1e; font-size: 12px; font-weight: 700; height: 80px; display: flex; align-items: center; text-transform: uppercase;">
                            Rejected: {{ approvalSignatures()[0]?.approval?.comment || 'No reason provided' }}
                        </div>
                        <img v-else-if="approvalSignatures()[0]?.user?.signature" :src="fileUrl(approvalSignatures()[0]?.user?.signature)" alt="" style="max-height: 80px !important; width: auto !important;"/>
                        <p style="margin-bottom: 0px;">{{ approvalSignatures()[0]?.user?.name || '-' }}</p>
                        <p style="margin-bottom: 0px;">{{ formatDate(approvalSignatures()[0]?.date, false) }}</p>
                    </div>
                    <div class="col-md-2" style="margin-right: 16px;">
                        <p style="margin-bottom: 0px; font-size: 18px !important;">HOD/Lead;</p>
                        <div v-if="approvalSignatures()[1]?.isRejected" style="color: #b41e1e; font-size: 12px; font-weight: 700; height: 80px; display: flex; align-items: center; text-transform: uppercase;">
                            Rejected: {{ approvalSignatures()[1]?.approval?.comment || 'No reason provided' }}
                        </div>
                        <img v-else-if="approvalSignatures()[1]?.user?.signature" :src="fileUrl(approvalSignatures()[1]?.user?.signature)" alt="" style="max-height: 80px !important; width: auto !important;"/>
                        <p style="margin-bottom: 0px;">{{ approvalSignatures()[1]?.user?.name || '-' }}</p>
                        <p style="margin-bottom: 0px;">{{ formatDate(approvalSignatures()[1]?.date, false) }}</p>
                    </div>
                    <div class="col-md-2" v-if="showFinanceApprovalColumn">
                        <p style="margin-bottom: 0px; font-size: 18px !important;">Finance;</p>
                        <div v-if="approvalSignatures()[2]?.isRejected" style="color: #b41e1e; font-size: 12px; font-weight: 700; height: 80px; display: flex; align-items: center; text-transform: uppercase;">
                            Rejected: {{ approvalSignatures()[2]?.approval?.comment || 'No reason provided' }}
                        </div>
                        <img v-else-if="approvalSignatures()[2]?.user?.signature" :src="fileUrl(approvalSignatures()[2]?.user?.signature)" alt="" style="max-height: 80px !important; width: auto !important;"/>
                        <p style="margin-bottom: 0px;">{{ approvalSignatures()[2]?.user?.name || '-' }}</p>
                        <p style="margin-bottom: 0px;">{{ formatDate(approvalSignatures()[2]?.date, false) }}</p>
                    </div>
                     <div class="col-md-2" v-if="showCeoApprovalColumn">
                        <p style="margin-bottom: 0px; font-size: 18px !important;">CEO</p>
                        <div v-if="approvalSignatures()[3]?.isRejected" style="color: #b41e1e; font-size: 12px; font-weight: 700; height: 80px; display: flex; align-items: center; text-transform: uppercase;">
                            Rejected: {{ approvalSignatures()[3]?.approval?.comment || 'No reason provided' }}
                        </div>
                        <img v-else-if="approvalSignatures()[3]?.user?.signature" :src="fileUrl(approvalSignatures()[3]?.user?.signature)" alt="" style="max-height: 80px !important; width: auto !important;"/>
                        <p style="margin-bottom: 0px;">{{ approvalSignatures()[3]?.user?.name || '-' }}</p>
                        <p style="margin-bottom: 0px;">{{ formatDate(approvalSignatures()[3]?.date, false) }}</p>
                    </div>
                </div>
            </div>
        </div>
        </template>

        <template v-slot:footer>
            <button class="btn btn-default" style="border: 1px solid black; float: right;" @click="downloadPDF">Download Pdf</button>
            <button class="btn btn-default" style="border: 1px solid black; float: right;" @click="copyToClipboard">Copy Pdf Link</button>
            <button class="btn btn-default" style="border: 1px solid black; float: right;" @click="sendMail">Send Mail</button>

            <button class="btn btn-default" style="border: 1px solid black; float: right; margin-right: 20px;" @click="$router.back()">Cancel</button>
        </template>
    </PdfModal>
   
</div>
  </template>
  
<script>
import Swal from "sweetalert2";
import html2pdf from "html2pdf.js";
import PdfModal from "@/components/PdfModal.vue";
import axios from 'axios'
import defaultLogo from '@/assets/images/logo.png'
import { CEO_NET_AMOUNT_THRESHOLD, hidePostHodApprovalColumns } from '@/constants/purchaseCeoThreshold.js'

export default {
    name: 'PurchasePdf',
    data: () => ({
        CEO_NET_AMOUNT_THRESHOLD,
        token: JSON.parse(localStorage.getItem('access_token')),
        urlServer:process.env.VUE_APP_URL,
        purchaseId: "",
        purchase:"",
        actionedBy:"",
        user:"",
        updateCount:1,
        loading: true,
        spinnerColor:'#ff1d5e',
        totalPrice:0,
        totalVat:0,
        totalFinal:0,
        discountAmount: 0,
        profile: {},
        defaultLogo: defaultLogo,
        pdfLink: ""
    }),

    components: {
        PdfModal
    },

    computed: {
        requesterUser() {
            const p = this.purchase || {};
            // Prefer requester from tender submission -> tender -> purchaseRequest
            if (p.tenderSubmission && p.tenderSubmission.tender && p.tenderSubmission.tender.purchaseRequest && p.tenderSubmission.tender.purchaseRequest.requestedBy) {
                return p.tenderSubmission.tender.purchaseRequest.requestedBy;
            }
            // Fallback to Tender -> purchaseRequest -> requestedBy
            if (p.Tender && p.Tender.purchaseRequest && p.Tender.purchaseRequest.requestedBy) {
                return p.Tender.purchaseRequest.requestedBy;
            }
            // Final fallback to purchase creator
            return p.User || null;
        },

        requesterDate() {
            const p = this.purchase || {};
            const prFromSubmission = p.tenderSubmission && p.tenderSubmission.tender && p.tenderSubmission.tender.purchaseRequest;
            const prFromTender = p.Tender && p.Tender.purchaseRequest;
            const pr = prFromSubmission || prFromTender || null;
            return (pr && pr.createdAt) || p.createdAt || null;
        },

        currency() {
            const p = this.purchase || {};
            const submission = p.tenderSubmission;
            if (submission && submission.proposedCurrency) return submission.proposedCurrency;
            
            // Tender fallback
            if (p.Tender && p.Tender.currency) return p.Tender.currency;
            if (p.tender && p.tender.currency) return p.tender.currency;
            
            // Default to KES
            return 'KES';
        },

        purchaseRequestItems() {
            const purchase = this.purchase || {};
            return purchase?.tenderSubmission?.tender?.purchaseRequest?.items
                || purchase?.Tender?.purchaseRequest?.items
                || [];
        },

        purchaseItemVehicles() {
            const purchaseProducts = Array.isArray(this.purchase?.PurchaseProduct)
                ? this.purchase.PurchaseProduct
                : [];
            const requestItems = Array.isArray(this.purchaseRequestItems)
                ? this.purchaseRequestItems
                : [];
            const seenVehicleIds = new Set();
            const resolvedVehicles = [];

            for (const purchaseItem of purchaseProducts) {
                const matchedRequestItems = requestItems.filter((requestItem) => {
                    const sameProduct = purchaseItem?.productId && requestItem?.productId
                        ? Number(purchaseItem.productId) === Number(requestItem.productId)
                        : false;
                    const sameService = purchaseItem?.serviceId && requestItem?.serviceId
                        ? Number(purchaseItem.serviceId) === Number(requestItem.serviceId)
                        : false;

                    return sameProduct || sameService;
                });

                for (const requestItem of matchedRequestItems) {
                    for (const vehicle of requestItem?.vehicles || []) {
                        if (!vehicle?.id || seenVehicleIds.has(vehicle.id)) {
                            continue;
                        }

                        seenVehicleIds.add(vehicle.id);
                        resolvedVehicles.push(vehicle);
                    }
                }
            }

            return resolvedVehicles;
        },

        purchaseItemVehicleLabels() {
            return this.purchaseItemVehicles
                .map((vehicle) => {
                    if (!vehicle) return '';

                    const details = [vehicle.model]
                        .filter(Boolean)
                        .join(' ');

                    return details
                        ? `${details} - ${vehicle.plateNumber}`
                        : (vehicle.plateNumber || '');
                })
                .filter(Boolean)
                .join(', ');
        },

        /** Line total after discount %, excl. VAT — same rule as backend CEO threshold */
        purchaseNetExclusive() {
            const sum = Number(this.totalPrice) || 0;
            const disc = Number(this.discountAmount) || 0;
            return Math.max(0, sum - disc);
        },

        isPurchaseRejected() {
            const s = (this.purchase && this.purchase.status != null)
                ? String(this.purchase.status).toLowerCase().trim()
                : '';
            return s === 'rejected';
        },

        /** Finance column hidden when PO was rejected at HOD/stamping (workflow type stamp) */
        showFinanceApprovalColumn() {
            return !hidePostHodApprovalColumns(this.purchase);
        },

        showCeoApprovalColumn() {
            return this.purchaseNetExclusive >= this.CEO_NET_AMOUNT_THRESHOLD && !hidePostHodApprovalColumns(this.purchase);
        }
    },

    async mounted(){
        this.purchaseId = this.$route.params.id
        this.loading = true
        await this.setupPurchase(this.purchaseId)
        await this.setupUser()
        this.profile = JSON?.parse(localStorage.getItem('profile'))
        this.loading = false
    },
    methods: {
        fileUrl(path) {
            if (!path) return '';
            if (String(path).startsWith('http')) return path;
            const p = String(path).replace(/^\//, '');
            const parts = p.split('/');
            if (parts.length === 1) return `${this.urlServer}/files/${parts[0]}`;
            const folder = parts[0];
            const file = parts.slice(1).join('/');
            return `${this.urlServer}/files/${folder}/${file}`;
        },

        approvalSignatures() {
            if (!this.purchase || !this.purchase.Approval) return [];
            // Include records that are approved, completed, or rejected
            const done = this.purchase.Approval.filter(a => a.type === 'approved' || a.status === 'done' || a.status === 'rejected');
            return done.map(a => {
                const user = a.approvedBy || a.requestedBy || null;
                const date = a.updatedAt || a.approvedAt || a.createdAt || null;
                return { 
                    user, 
                    date, 
                    approval: a, 
                    isRejected: a.type === 'rejected' || a.status === 'rejected' 
                };
            }).filter(o => o.user);
        },
        async exportToPDF() {
            this.generatePdf()
            this.$router.back()
        },

        downloadPDF(){
            html2pdf(document.getElementById("pdfStart"), {
                margin: 0.2,
                filename: new Date().getTime() + "_purchase_order.pdf",
                image: { type: 'jpeg', quality: 1.00 },
                html2canvas: { scale: 2, useCORS: true },
                jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' },
            });
        },

        async generatePdf(){
            try{
                Swal.fire({
                    html: "Generating pdf",
                    timer: 2000,
                    timerProgressBar: true,
                    didOpen: () => {
                        Swal.showLoading();
                    }
                    }).then((result) => {
                    if (result.dismiss === Swal.DismissReason.timer) {
                        console.log("I was closed by the timer");
                    }
                    });
                    const response = await axios.get(`${process.env.VUE_APP_URL}/pdf/purchase/${this.purchaseId}`)
                console.log(response)
            }catch(err){
                console.log(err)
            }finally{
                console.log("finally")
            } 
        },
        
        closeModal(){
            this.$router.back()
        },

        async copyToClipboard(){
            try {
                await navigator.clipboard.writeText(`${process.env.VUE_APP_URL}/purchases/pdf/${this.purchaseId}`);
                alert('Pdf link copied')
            } catch (err) {
                console.error('Failed to copy text to clipboard', err);
            }
        },

        formatBoolean(value){
            if(value){
            return "YES"
            } else{
            return "NO"
            }
        },
        calculatePrice(products){
            // compute totals based on item price * quantity
            const sum = (products || []).reduce((acc, p) => {
                const price = Number(p.price) || 0
                const qty = Number(p.quantity) || 0
                return acc + price * qty
            }, 0)
            this.totalPrice = sum
            const discountPercent = Number(this.purchase?.discount) || 0
            this.discountAmount = sum * (discountPercent / 100)
            const taxableBase = Math.max(0, sum - this.discountAmount)
            this.totalVat = this.purchase && this.purchase.vat ? taxableBase * 0.16 : 0
            this.totalFinal = taxableBase + this.totalVat
        },

        formatDate(value, showTime) {
            if (!value) return '';
            try {
                const d = new Date(value);
                if (isNaN(d.getTime())) return String(value);
                if (showTime === true || showTime === 'true') {
                    // show date and time without seconds (hour:minute)
                    return d.toLocaleString(undefined, { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' });
                }
                return d.toLocaleDateString(undefined, { year: 'numeric', month: '2-digit', day: '2-digit' });
            } catch (e) {
                return String(value);
            }
        },

        sendEmail(){
            const subject = encodeURIComponent(`Purchase Order ${this.purchase?.purchaseNo || this.purchaseId}`);
            const body = encodeURIComponent(`Please find the purchase order here: ${this.pdfLink}\n\nRegards,`);
            // mailto will open the user's default mail client
            window.location.href = `mailto:?subject=${subject}&body=${body}`;
        },

        async sendMail(){
            // Step 1: generate & download the PDF
            const filename = `PO_${this.purchase?.purchaseNo || this.purchaseId}.pdf`;
            await html2pdf().set({
                margin: 0.2,
                filename,
                image: { type: 'jpeg', quality: 1.00 },
                html2canvas: { scale: 2, useCORS: true },
                jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' },
            }).from(document.getElementById('pdfStart')).save();

            // Step 2: open Outlook compose (browser cannot pre-attach files)
            const to      = encodeURIComponent(this.purchase?.Supplier?.email || '');
            const subject = encodeURIComponent(`Purchase Order ${this.purchase?.purchaseNo || this.purchaseId}`);
            const body    = encodeURIComponent(`Dear ${this.purchase?.Supplier?.name || 'Sir/Madam'},\n\nPlease find the Purchase Order attached.\n\nRegards,\nProcurement Team\nprocurement@pavicongroup.com`);
            const from    = encodeURIComponent('procurement@pavicongroup.com');
            window.open(`https://outlook.office.com/mail/deeplink/compose?to=${to}&from=${from}&subject=${subject}&body=${body}`, '_blank');

            // Step 3: remind user to attach the downloaded file
            Swal.fire({
                icon: 'info',
                title: 'PDF Downloaded',
                text: `"${filename}" has been saved to your downloads. Please attach it to the Outlook email that just opened.`,
                confirmButtonText: 'Got it',
            });
        },

        async setupPurchase(itemId){
            const requestOptions = {
                method: "GET",
                headers: { "Content-Type": "application/json",'Authorization': 'Bearer '+this.token },
            };
            const res = await fetch(process.env.VUE_APP_URL+'/purchases/'+itemId, requestOptions)
            const data = await res.json()
            if(data.status == true){
                this.purchase = data.purchase;
                this.actionedBy = data.actionedBy;
                this.calculatePrice(data.purchase.PurchaseProduct)
                this.pdfLink = `${process.env.VUE_APP_URL}/pdf/purchase/${this.purchaseId}`
                //this.generateQRCode(this.pdfLink)
                //this.pdfLink = this.shortenUrl(`${process.env.VUE_FRONT_URL}/purchases/pdf/${this.purchaseId}`)
            }else{
                Swal.fire({
                    icon: 'error',
                    title: 'Purchase Note not found. Try again',
                    text: data.message
                })
            }
        },

        async setupUser(){
            const requestOptions = {
                method: "GET",
                headers: { "Content-Type": "application/json", 'Authorization': 'Bearer '+this.token },
            };
            const res = await fetch(process.env.VUE_APP_URL+'/users/profile', requestOptions)
            const data = await res.json()
            if(data.status == true){
                this.user = data.user;
            }else{
                Swal.fire({
                    icon: 'error',
                    title: 'Purchase Note not found. Try again',
                    text: data.message
                })
            }
        },

    }
}
</script>

<style scoped>
p, span, h3, h4, th, td, tr{
    color: #000 !important;
}
h3{
    font-size: 33px !important;
}
h4{
    font-weight: bold !important;
}
#companyDetails h4{
    text-align: right;
    font-size: 19px;
}
#footer p{
    font-size: 11px !important;
}
.row{
    margin-top: 20px;
}
.lds-roller {
  display: inline-block;
  position: relative;
  width: 20px;
  height: 20px;
  margin: auto;
  display: block;
}
.lds-roller div {
  animation: lds-roller 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  transform-origin: 40px 40px;
}
.lds-roller div:after {
  content: " ";
  display: block;
  position: absolute;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #000000;
  margin: -4px 0 0 -4px;
}
.lds-roller div:nth-child(1) {
  animation-delay: -0.036s;
}
.lds-roller div:nth-child(1):after {
  top: 63px;
  left: 63px;
}
.lds-roller div:nth-child(2) {
  animation-delay: -0.072s;
}
.lds-roller div:nth-child(2):after {
  top: 68px;
  left: 56px;
}
.lds-roller div:nth-child(3) {
  animation-delay: -0.108s;
}
.lds-roller div:nth-child(3):after {
  top: 71px;
  left: 48px;
}
.lds-roller div:nth-child(4) {
  animation-delay: -0.144s;
}
.lds-roller div:nth-child(4):after {
  top: 72px;
  left: 40px;
}
.lds-roller div:nth-child(5) {
  animation-delay: -0.18s;
}
.lds-roller div:nth-child(5):after {
  top: 71px;
  left: 32px;
}
.lds-roller div:nth-child(6) {
  animation-delay: -0.216s;
}
.lds-roller div:nth-child(6):after {
  top: 68px;
  left: 24px;
}
.lds-roller div:nth-child(7) {
  animation-delay: -0.252s;
}
.lds-roller div:nth-child(7):after {
  top: 63px;
  left: 17px;
}
.lds-roller div:nth-child(8) {
  animation-delay: -0.288s;
}
.lds-roller div:nth-child(8):after {
  top: 56px;
  left: 11px;
}
@keyframes lds-roller {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.pdf-preview-root {
  position: relative;
  overflow: hidden;
}

.po-rejected-watermark {
  position: absolute;
  inset: 0;
  z-index: 5;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  font-size: clamp(48px, 14vw, 120px);
  font-weight: 800;
  letter-spacing: 0.12em;
  color: rgba(180, 30, 30, 0.22);
  text-transform: uppercase;
  transform: rotate(-32deg);
  user-select: none;
}

</style>
